export interface Chapter {
  id: number;
  title: string;
  number: number;
  updateDate: string;
  viewCount: number;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  viewCount: number;
  likeCount: number;
  updateDate: string;
  tags: string[];
  chapters: Chapter[];
  featured: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '动作', slug: 'action' },
  { name: '耽美', slug: 'bl' },
  { name: '剧情', slug: 'drama' },
  { name: '恐怖', slug: 'horror' },
  { name: '搞笑', slug: 'comedy' },
  { name: '悬疑', slug: 'mystery' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '深渊之花',
    author: '金秀贤',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20woman%20with%20dark%20hair%20surrounded%20by%20glowing%20magical%20flowers%20in%20an%20abyss%2C%20dramatic%20lighting%2C%20soft%20watercolor%20texture%2C%20ethereal%20atmosphere%2C%20clean%20minimal%20background%20with%20subtle%20sparkles&width=400&height=560&seq=manhwa-cover-01&orientation=portrait',
    description: '在一座被黑暗笼罩的古老城市中，少女艾琳意外发现自己拥有穿越深渊的能力。深渊之中隐藏着无数秘密与危险，而她必须在这片未知领域中寻找拯救家人的方法。一场关于勇气、友情与命运的奇幻冒险就此展开。',
    status: '连载中',
    rating: 4.8,
    viewCount: 1258000,
    likeCount: 89600,
    updateDate: '2026-08-03',
    tags: ['奇幻', '冒险', '女性主角', '魔法'],
    featured: true,
    chapters: [
      { id: 101, title: '第120话 - 深渊的尽头', number: 120, updateDate: '2026-08-03', viewCount: 45600 },
      { id: 100, title: '第119话 - 最后的试炼', number: 119, updateDate: '2026-07-27', viewCount: 48200 },
      { id: 99, title: '第118话 - 黑暗中的光芒', number: 118, updateDate: '2026-07-20', viewCount: 51300 },
      { id: 98, title: '第117话 - 守护者的抉择', number: 117, updateDate: '2026-07-13', viewCount: 49700 },
      { id: 97, title: '第116话 - 命运的齿轮', number: 116, updateDate: '2026-07-06', viewCount: 52800 },
    ],
  },
  {
    id: 2,
    title: '契约婚姻',
    author: '李恩在',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20style%20illustration%20of%20a%20couple%20in%20elegant%20wedding%20attire%20standing%20back%20to%20back%20with%20subtle%20tension%2C%20soft%20pink%20and%20white%20color%20palette%2C%20delicate%20cherry%20blossom%20petals%2C%20clean%20minimal%20background&width=400&height=560&seq=manhwa-cover-02&orientation=portrait',
    description: '为了挽救家族企业，姜瑞妍被迫与财阀继承人车敏俊签订契约婚姻。两个毫无感情基础的人在同一屋檐下生活，却在日常相处中逐渐被对方吸引。当契约即将到期，他们能否坦诚面对自己的真心？',
    status: '连载中',
    rating: 4.7,
    viewCount: 2130000,
    likeCount: 152000,
    updateDate: '2026-08-02',
    tags: ['恋爱', '契约婚姻', '财阀', '甜宠'],
    featured: true,
    chapters: [
      { id: 201, title: '第85话 - 真心话', number: 85, updateDate: '2026-08-02', viewCount: 67800 },
      { id: 200, title: '第84话 - 意外的告白', number: 84, updateDate: '2026-07-26', viewCount: 71200 },
      { id: 199, title: '第83话 - 动摇的心', number: 83, updateDate: '2026-07-19', viewCount: 69500 },
    ],
  },
  {
    id: 3,
    title: '猎魔人传说',
    author: '朴志勋',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20action%20scene%20of%20a%20male%20hunter%20holding%20a%20glowing%20sword%20facing%20shadowy%20monsters%2C%20intense%20red%20and%20black%20color%20scheme%2C%20dramatic%20lighting%2C%20clean%20minimal%20background&width=400&height=560&seq=manhwa-cover-03&orientation=portrait',
    description: '在一个妖魔横行的世界里，猎魔人是人类最后的希望。少年韩真宇继承了父亲的猎魔人血脉，踏上了消灭妖魔、守护人间的道路。热血沸腾的战斗场面，感人至深的兄弟情谊，一部不容错过的动作巨作。',
    status: '已完结',
    rating: 4.9,
    viewCount: 3890000,
    likeCount: 245000,
    updateDate: '2026-06-15',
    tags: ['动作', '热血', '猎魔', '奇幻'],
    featured: true,
    chapters: [
      { id: 301, title: '第200话 - 终章：新的开始', number: 200, updateDate: '2026-06-15', viewCount: 89200 },
      { id: 302, title: '第199话 - 最终决战', number: 199, updateDate: '2026-06-08', viewCount: 87500 },
      { id: 303, title: '第198话 - 觉醒的力量', number: 198, updateDate: '2026-06-01', viewCount: 86100 },
    ],
  },
  {
    id: 4,
    title: '星光之恋',
    author: '崔美英',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20couple%20looking%20at%20stars%20together%20on%20a%20rooftop%20at%20night%2C%20warm%20yellow%20starlight%2C%20soft%20romantic%20atmosphere%2C%20clean%20minimal%20background%20with%20night%20sky&width=400&height=560&seq=manhwa-cover-04&orientation=portrait',
    description: '天文系学生林星儿在屋顶观星时，偶然遇到了隔壁音乐系的校草郑宇辰。两个来自不同世界的人因为对星空的热爱而走到一起。这是一段温暖治愈的校园恋爱故事，让人相信最美的爱情就在平凡日常中。',
    status: '连载中',
    rating: 4.6,
    viewCount: 1560000,
    likeCount: 108000,
    updateDate: '2026-08-01',
    tags: ['恋爱', '校园', '治愈', '甜宠'],
    featured: false,
    chapters: [
      { id: 401, title: '第62话 - 流星雨之夜', number: 62, updateDate: '2026-08-01', viewCount: 39800 },
      { id: 402, title: '第61话 - 心动的信号', number: 61, updateDate: '2026-07-25', viewCount: 41200 },
    ],
  },
  {
    id: 5,
    title: '暗夜追踪者',
    author: '姜宇镇',
    category: '悬疑',
    categorySlug: 'mystery',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20thrilling%20Korean%20manhwa%20noir%20style%20detective%20in%20a%20trench%20coat%20standing%20under%20a%20streetlamp%20in%20rain%2C%20moody%20atmosphere%2C%20deep%20shadows%2C%20clean%20minimal%20background%20with%20fog&width=400&height=560&seq=manhwa-cover-05&orientation=portrait',
    description: '首尔连续发生离奇失踪案件，刑警金道贤在追查过程中发现了一个惊人的秘密——所有失踪者都与十年前的一桩悬案有关。随着调查深入，他发现自己竟然也成为了目标。一场惊心动魄的追踪与反追踪游戏就此展开。',
    status: '连载中',
    rating: 4.5,
    viewCount: 980000,
    likeCount: 67300,
    updateDate: '2026-07-30',
    tags: ['悬疑', '推理', '刑侦', '都市'],
    featured: false,
    chapters: [
      { id: 501, title: '第45话 - 真相浮现', number: 45, updateDate: '2026-07-30', viewCount: 32400 },
      { id: 502, title: '第44话 - 关键线索', number: 44, updateDate: '2026-07-23', viewCount: 33800 },
    ],
  },
  {
    id: 6,
    title: '魔王大人的甜点屋',
    author: '尹素熙',
    category: '搞笑',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20manhwa%20style%20illustration%20of%20a%20demon%20lord%20wearing%20a%20cute%20apron%20holding%20a%20cake%20in%20a%20cozy%20bakery%2C%20warm%20colorful%20pastel%20tone%2C%20humorous%20expression%2C%20clean%20minimal%20background&width=400&height=560&seq=manhwa-cover-06&orientation=portrait',
    description: '曾经统治魔界的魔王路西法因为厌倦了打打杀杀，决定隐退到人间开一家甜点屋。然而，他完全不会做甜点！在人类少女小桃的帮助下，魔王开始了啼笑皆非的甜点师修行之旅。轻松搞笑的日常，让人捧腹大笑。',
    status: '连载中',
    rating: 4.4,
    viewCount: 1870000,
    likeCount: 134000,
    updateDate: '2026-08-03',
    tags: ['搞笑', '日常', '美食', '奇幻'],
    featured: true,
    chapters: [
      { id: 601, title: '第78话 - 魔王级马卡龙', number: 78, updateDate: '2026-08-03', viewCount: 52100 },
      { id: 602, title: '第77话 - 甜点大赛', number: 77, updateDate: '2026-07-27', viewCount: 54800 },
    ],
  },
  {
    id: 7,
    title: '血色玫瑰',
    author: '韩素拉',
    category: '恐怖',
    categorySlug: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20creepy%20Korean%20manhwa%20horror%20illustration%20of%20a%20pale%20woman%20holding%20a%20blood-red%20rose%20with%20dark%20shadows%20behind%20her%2C%20gothic%20atmosphere%2C%20deep%20red%20accents%20on%20dark%20background%2C%20haunting%20expression&width=400&height=560&seq=manhwa-cover-07&orientation=portrait',
    description: '在一座古老的庄园中，每到月圆之夜，花园里就会盛开血红色的玫瑰。庄园的女主人邀请了几位客人前来做客，然而客人们一个接一个地离奇死亡。隐藏在玫瑰背后的恐怖真相究竟是什么？',
    status: '已完结',
    rating: 4.3,
    viewCount: 1450000,
    likeCount: 98700,
    updateDate: '2026-05-20',
    tags: ['恐怖', '悬疑', '哥特', '推理'],
    featured: false,
    chapters: [
      { id: 701, title: '第60话 - 玫瑰的真相（终章）', number: 60, updateDate: '2026-05-20', viewCount: 61200 },
      { id: 702, title: '第59话 - 最后的幸存者', number: 59, updateDate: '2026-05-13', viewCount: 59800 },
    ],
  },
  {
    id: 8,
    title: '重生之逆天改命',
    author: '张明宇',
    category: '剧情',
    categorySlug: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20determined%20young%20man%20looking%20at%20his%20reflection%20in%20a%20mirror%20showing%20a%20different%20timeline%2C%20golden%20light%2C%20split%20composition%2C%20clean%20minimal%20background&width=400&height=560&seq=manhwa-cover-08&orientation=portrait',
    description: '被背叛至死的商人林浩然，意外重回到二十年前。带着前世的记忆和经验，他决定改写自己的命运，向那些曾经伤害过他的人一一复仇。然而，当一切按照计划进行时，他发现事情远比他想象的复杂。',
    status: '连载中',
    rating: 4.8,
    viewCount: 2760000,
    likeCount: 198000,
    updateDate: '2026-08-04',
    tags: ['剧情', '重生', '商战', '复仇'],
    featured: true,
    chapters: [
      { id: 801, title: '第95话 - 棋局逆转', number: 95, updateDate: '2026-08-04', viewCount: 58700 },
      { id: 802, title: '第94话 - 暗流涌动', number: 94, updateDate: '2026-07-28', viewCount: 60200 },
    ],
  },
  {
    id: 9,
    title: '樱花树下的约定',
    author: '宋智恩',
    category: '耽美',
    categorySlug: 'bl',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20BL%20style%20illustration%20of%20two%20young%20men%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20tender%20gaze%2C%20soft%20pink%20petals%2C%20spring%20atmosphere%2C%20clean%20minimal%20background&width=400&height=560&seq=manhwa-cover-09&orientation=portrait',
    description: '高中时代，李玄宇和姜泰俊曾在樱花树下许下约定——无论未来如何，都要在一起。十年后，两人在职场重逢，当年的青涩少年已经成长为成熟的男人。樱花依旧盛开，但那份约定还能实现吗？',
    status: '连载中',
    rating: 4.7,
    viewCount: 1650000,
    likeCount: 121000,
    updateDate: '2026-07-31',
    tags: ['耽美', '重逢', '职场', '治愈'],
    featured: false,
    chapters: [
      { id: 901, title: '第55话 - 樱花再开', number: 55, updateDate: '2026-07-31', viewCount: 43500 },
      { id: 902, title: '第54话 - 十年后的重逢', number: 54, updateDate: '2026-07-24', viewCount: 45800 },
    ],
  },
  {
    id: 10,
    title: '仙境传说',
    author: '金泰亨',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20warrior%20with%20magical%20armor%20in%20a%20floating%20island%20paradise%2C%20crystal%20clear%20waterfalls%2C%20majestic%20scenery%2C%20epic%20composition%2C%20clean%20minimal%20background&width=400&height=560&seq=manhwa-cover-10&orientation=portrait',
    description: '普通高中生李允浩在图书馆发现了一本古老的书籍，翻开后竟被吸入了一个名为「仙境」的异世界。在这里，他必须完成七个试炼才能回到现实世界。一场跨越两个世界的奇幻冒险就此展开。',
    status: '连载中',
    rating: 4.6,
    viewCount: 1120000,
    likeCount: 78500,
    updateDate: '2026-07-29',
    tags: ['奇幻', '冒险', '异世界', '游戏'],
    featured: false,
    chapters: [
      { id: 1001, title: '第42话 - 第五试炼', number: 42, updateDate: '2026-07-29', viewCount: 31200 },
      { id: 1002, title: '第41话 - 守护者之塔', number: 41, updateDate: '2026-07-22', viewCount: 32800 },
    ],
  },
  {
    id: 11,
    title: '办公室罗曼史',
    author: '朴敏英',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20office%20setting%20with%20a%20handsome%20male%20boss%20and%20female%20employee%20sharing%20a%20coffee%20moment%2C%20modern%20office%20background%2C%20warm%20lighting%2C%20clean%20minimal%20composition&width=400&height=560&seq=manhwa-cover-11&orientation=portrait',
    description: '职场新人韩素恩入职第一天就发现自己的直属上司是大学时期的暗恋对象——沈俊昊。更糟糕的是，沈俊昊似乎完全不记得她了。在紧张忙碌的职场生活中，两人之间的关系悄然发生着变化。',
    status: '连载中',
    rating: 4.5,
    viewCount: 1340000,
    likeCount: 92000,
    updateDate: '2026-07-28',
    tags: ['恋爱', '职场', '暗恋', '甜宠'],
    featured: false,
    chapters: [
      { id: 1101, title: '第38话 - 加班之夜', number: 38, updateDate: '2026-07-28', viewCount: 28900 },
      { id: 1102, title: '第37话 - 咖啡里的秘密', number: 37, updateDate: '2026-07-21', viewCount: 30400 },
    ],
  },
  {
    id: 12,
    title: '灵能侦探社',
    author: '郑基石',
    category: '悬疑',
    categorySlug: 'mystery',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20style%20illustration%20of%20a%20detective%20with%20glowing%20eyes%20seeing%20spirits%20in%20an%20old%20office%2C%20supernatural%20elements%2C%20eerie%20green%20glow%2C%20noir%20atmosphere%2C%20clean%20minimal%20background&width=400&height=560&seq=manhwa-cover-12&orientation=portrait',
    description: '退役刑警崔民秀因一次意外获得了看见灵魂的能力。他开设了一家灵能侦探社，专门处理普通警察无法解决的超自然案件。每个案件背后都隐藏着令人心碎的真相，而他也在这个过程治愈着自己的创伤。',
    status: '连载中',
    rating: 4.4,
    viewCount: 890000,
    likeCount: 61000,
    updateDate: '2026-07-25',
    tags: ['悬疑', '超自然', '侦探', '治愈'],
    featured: false,
    chapters: [
      { id: 1201, title: '第30话 - 失踪的灵魂', number: 30, updateDate: '2026-07-25', viewCount: 25600 },
      { id: 1202, title: '第29话 - 镜中人', number: 29, updateDate: '2026-07-18', viewCount: 27100 },
    ],
  },
];